import { defineFetch } from 'resift';

const makeDeleteRole = defineFetch({
  displayName: 'Delete Role',
  make: (roleId: string) => ({
    request: () => ({ http }) =>
      http({
        method: 'DELETE',
        route: `/roles/${roleId}`,
      }),
  }),
});

export default makeDeleteRole;
